<div
    class="mb-3 border-gray border-radius-5"
    [formGroup]="_form.form"
>
    <div class="section-head">
        <div class="flex-grow-1 px-2">
            <cmps-icon svgIcon="headset"></cmps-icon>
            <span
                >&nbsp;{{ _i18n._9652_INTERACTION_REF | translate }}
                {{ _value.identifier }}</span
            >
        </div>
        <div class="px-2">
            <span>{{ _i18n._9715_QUEUE_ | translate }}&nbsp;</span>
            <ng-select
                #dropDownQueue
                class="ng-select--variant-2"
                [options]="_queueOpts"
                [formControlName]="_InteractionFormFields.QUEUE.name"
                (opened)="_onDropdownOpen()"
            ></ng-select>
        </div>
        <div
            class="px-2"
            *ngIf="_menuOpts?.length"
        >
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [cmpsMenuTrigger]="menu"
                placement="bottom-right"
            >
                <cmps-icon svgIcon="dots-horizontal"></cmps-icon>
            </button>
            <cmps-menu #menu="cmpsMenu">
                <ng-container *ngFor="let item of _menuOpts">
                    <button
                        class="cmps-button--no-bg cmps-button--left"
                        cmpsButton
                        (click)="_onMenuItemClick(item)"
                    >
                        <cmps-icon [svgIcon]="item.icon"></cmps-icon>
                        <span cmpsButtonLabel>{{ item.label }}</span>
                    </button>
                </ng-container>
            </cmps-menu>
        </div>
    </div>

    <div class="section-body">
        <div class="col-12">
            <div
                class="row my-3"
                *ngIf="_form.errors['IDENTIFIER']"
            >
                <div class="col-12">
                    <div class="h6 m-0 text-center alert-warning-compas">
                        {{ _form.errors['IDENTIFIER'] }}
                    </div>
                </div>
            </div>
            <div
                class="row my-3"
                data-e2e="alert-time"
                *ngIf="_form.errors['TIME']"
            >
                <div class="col-12">
                    <div class="h6 m-0 text-center alert-warning-compas">
                        {{ _form.errors['TIME'] }}
                    </div>
                </div>
            </div>
            <div
                class="row my-3"
                *ngIf="_form.errors['DATE']"
            >
                <div class="col-12">
                    <div class="h6 m-0 text-center alert-warning-compas">
                        {{ _form.errors['DATE'] }}
                    </div>
                </div>
            </div>

            <div class="row my-3">
                <div class="col-md-12 col-sm">
                    <div class="row">
                        <div class="col-3 pr-2">
                            <div class="row">
                                <label
                                    id="interactionIdentifier-label"
                                    class="text-right col-md-4 col-sm col-form-label"
                                >
                                    {{
                                        _i18n._9652_INTERACTION_REF | translate
                                    }}
                                </label>
                                <div class="col-md-8 col-sm pr-2 pl-2">
                                    <input
                                        class="form-control"
                                        aria-labelledby="interactionIdentifier-label"
                                        [formControlName]="
                                            _InteractionFormFields.IDENTIFIER
                                                .name
                                        "
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="col-3 pr-2 pl-2">
                            <div class="row">
                                <label
                                    id="queue-label"
                                    class="text-right col-md-4 col-sm col-form-label"
                                >
                                    {{
                                        _i18n._7349_INTERACTION_TYPE | translate
                                    }}
                                </label>
                                <div class="col-md-8 col-sm pr-2 pl-2">
                                    <ng-select
                                        class="ng-select--variant-3 ng-select--variant-d"
                                        [options]="_interactionTypeOpts"
                                        [ariaLabelledBy]="'queue-label'"
                                        [formControlName]="
                                            _InteractionFormFields
                                                .INTERACTION_TYPE.name
                                        "
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <div class="col-3 pr-2 pl-2">
                            <div class="row">
                                <label
                                    id="interactionDate-label"
                                    class="text-right col-md-4 col-sm col-form-label"
                                >
                                    {{
                                        _i18n._7350_INTERACTION_DATE | translate
                                    }}
                                </label>
                                <div
                                    class="input-group col-md-8 col-sm pr-2 pl-2"
                                >
                                    <input
                                        class="form-control pl-1 pr-0"
                                        [maxDate]="_maxDateStruct"
                                        [minDate]="_minDateStruct"
                                        aria-labelledby="interactionDate-label"
                                        ngbDatepicker
                                        [formControlName]="
                                            _InteractionFormFields.DATE.name
                                        "
                                        #dp="ngbDatepicker"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            type="button"
                                            class="btn btn-secondary date-selector-btn"
                                            aria-label="Toggle date picker"
                                            [attr.aria-expanded]="dp.isOpen()"
                                            [disabled]="_form.form.disabled"
                                            (click)="dp.toggle()"
                                        >
                                            <cmps-icon
                                                class="formIcon"
                                                svgIcon="calendar-range"
                                            ></cmps-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-3 pl-2">
                            <div class="row">
                                <label
                                    id="interactionTime-label"
                                    class="text-right col-md-4 col-sm col-form-label"
                                >
                                    {{
                                        _i18n._9703_INTERACTION_TIME | translate
                                    }}
                                </label>
                                <div class="col-md-8 col-sm pl-2">
                                    <input
                                        class="form-control"
                                        (focus)="tp.open()"
                                        (click)="tp.open()"
                                        data-e2e="textbox-time"
                                        cmpsDateTimePicker
                                        [onlyTime]="true"
                                        [autoFocus]="false"
                                        [maxDate]="_maxDate"
                                        #tp="cmpsDateTimePicker"
                                        [formControlName]="
                                            _InteractionFormFields.TIME.name
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row my-3"
                *ngIf="config?.interactionPurposeEnabled"
            >
                <div class="col-md-12 col-sm">
                    <div class="row">
                        <div class="col-7">
                            <div class="row">
                                <label
                                    id="queue-label"
                                    class="col-md-4 col-sm col-form-label"
                                >
                                    {{
                                        _i18n._9704_INTERACTION_PURPOSE
                                            | translate
                                    }}
                                </label>
                                <div class="col-md-8 col-sm">
                                    <ng-select
                                        class="ng-select--variant-3 ng-select--variant-d"
                                        [disabled]="_form.form.disabled"
                                        [ariaLabelledBy]="'queue-label'"
                                        [options]="_interactionTriggerOpts"
                                        [formControlName]="
                                            _InteractionFormFields
                                                .INTERACTION_PURPOSE_ID.name
                                        "
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="_noteEntity?.enabled">
                <div class="row">
                    <div class="col-12">
                        <div
                            cmpsNotes
                            [config]="_noteEntity"
                            [defaultCategory]="defaultNoteCategory"
                            [hasCategoryBar]="true"
                            [formControlName]="
                                _InteractionFormFields.NOTES.name
                            "
                            #notes="cmpsNotes"
                        ></div>
                    </div>
                </div>

                <div
                    class="row"
                    *ngIf="!_form.form.disabled"
                >
                    <div class="col-12 d-flex justify-content-center">
                        <button
                            cmpsIconButton
                            (click)="notes.addNote()"
                        >
                            <cmps-icon svgIcon="plus"></cmps-icon>
                            <span cmpsIconButtonLabel>{{
                                _i18n._9705_ADD_AN_INTERACTION_NOTE | translate
                            }}</span>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>

        <hr *ngIf="_scoringEntity?.enabled && focus_?.behaviourId" />

        <div class="col-12 mb-3 p-0">
            <ng-container
                *ngIf="_scoringEntity?.enabled && focus_?.behaviourId"
            >
                <div
                    cmpsObservationScores
                    [config]="_scoringEntity"
                    [focus]="focus_"
                    [defaultNoteCategory]="defaultNoteCategory"
                    [formControlName]="_InteractionFormFields.SCORING.name"
                    [published]="published"
                ></div>
            </ng-container>
        </div>
    </div>
</div>
